import React, { useState, useEffect } from "react";
import { validateTimeRange } from "../../../../utils/timeValidation";

const TimeSlotsSection = ({
  slots,
  onChange,
  disabled = false,
  maxSlots = 6,
  minSlots = 1,
  onValidationChange,
}) => {
  const [timeSlotErrors, setTimeSlotErrors] = useState({});

  const validateSlot = (slot) => {
    if (!slot.start_time || !slot.end_time) return null;
    const validation = validateTimeRange(slot.start_time, slot.end_time);
    return validation.isValid ? null : validation.error;
  };

  useEffect(() => {
    const errors = {};
    slots.forEach((slot) => {
      const err = validateSlot(slot);
      if (err) errors[slot.id] = err;
    });
    setTimeSlotErrors(errors);
    if (onValidationChange) onValidationChange(errors);
  }, [slots]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSlotChange = (slotId, field, value) => {
    const updatedSlots = slots.map((slot) =>
      slot.id === slotId ? { ...slot, [field]: value } : slot
    );
    onChange(updatedSlots);

    if (field === "start_time" || field === "end_time") {
      const slot = updatedSlots.find((s) => s.id === slotId);
      const err = slot ? validateSlot(slot) : null;
      setTimeSlotErrors((prev) => {
        const next = { ...prev, [slotId]: err };
        if (onValidationChange) onValidationChange(next);
        return next;
      });
    }
  };

  const handleAddSlot = () => {
    if (slots.length >= maxSlots) {
      alert(`Maximum ${maxSlots} time slots allowed`);
      return;
    }
    const newSlot = {
      id: Date.now(),
      name: `Slot ${slots.length + 1}`,
      start_time: "12:00",
      end_time: "16:00",
    };
    onChange([...slots, newSlot]);
  };

  const handleRemoveSlot = (slotId) => {
    if (slots.length <= minSlots) {
      alert("Must have at least one time slot");
      return;
    }
    onChange(slots.filter((slot) => slot.id !== slotId));
    setTimeSlotErrors((prev) => {
      const next = { ...prev };
      delete next[slotId];
      if (onValidationChange) onValidationChange(next);
      return next;
    });
  };

  return (
    <div className="time-slots-preview">
      <p className="input-hint" style={{ marginTop: 0 }}>
        Named time slots for booking shows at this venue (separate from opening
        hours above).
      </p>
      {slots.map((slot, index) => (
        <div
          key={slot.id}
          className="time-slot-preview-item time-slot-item time-slot-row"
        >
          <div className="input-group">
            <label className="input-label">Slot Name</label>
            <input
              type="text"
              value={slot.name || ""}
              onChange={(e) =>
                handleSlotChange(slot.id, "name", e.target.value)
              }
              className="settings-input"
              placeholder="e.g., Early, Mid, Late"
              maxLength={50}
              disabled={disabled}
            />
          </div>
          <div className="input-group">
            <label className="input-label">Start Time</label>
            <input
              type="time"
              value={(slot.start_time || "").slice(0, 5)}
              onChange={(e) =>
                handleSlotChange(slot.id, "start_time", e.target.value)
              }
              className="settings-input"
              disabled={disabled}
            />
          </div>
          <div className="input-group">
            <label className="input-label">End Time</label>
            <input
              type="time"
              value={(slot.end_time || "").slice(0, 5)}
              onChange={(e) =>
                handleSlotChange(slot.id, "end_time", e.target.value)
              }
              className="settings-input"
              disabled={disabled}
            />
            {timeSlotErrors[slot.id] && (
              <div
                style={{
                  color: "var(--primary-red)",
                  fontSize: "0.85rem",
                  marginTop: "0.25rem",
                }}
              >
                {timeSlotErrors[slot.id]}
              </div>
            )}
          </div>
          {slots.length > minSlots && (
            <div className="time-slot-remove-wrap">
              <button
                type="button"
                className="remove-slot-btn"
                onClick={() => handleRemoveSlot(slot.id)}
                disabled={disabled}
                aria-label={`Remove slot ${index + 1}`}
              >
                Remove
              </button>
            </div>
          )}
        </div>
      ))}
      {slots.length < maxSlots && (
        <div className="time-slots-actions" style={{ marginTop: "1rem" }}>
          <button
            type="button"
            className="add-slot-btn"
            onClick={handleAddSlot}
            disabled={disabled}
          >
            + Add Time Slot
          </button>
        </div>
      )}
    </div>
  );
};

export default TimeSlotsSection;
